
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { X, Plus } from "lucide-react";

interface IngredientsListProps {
  ingredients: string[];
  updateIngredient: (index: number, value: string) => void;
  removeIngredient: (index: number) => void;
  addIngredient: () => void;
}

const IngredientsList: React.FC<IngredientsListProps> = ({
  ingredients,
  updateIngredient,
  removeIngredient,
  addIngredient,
}) => {
  return (
    <div className="space-y-2">
      <Label>Ingredients</Label>
      <div className="space-y-2">
        {ingredients.map((ingredient, index) => (
          <div key={`ingredient-${index}`} className="flex gap-2">
            <Input
              value={ingredient}
              onChange={(e) => updateIngredient(index, e.target.value)}
              placeholder="Enter an ingredient"
              className="flex-1"
            />
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={() => removeIngredient(index)}
              disabled={ingredients.length <= 1}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        ))}
        <Button
          type="button"
          variant="outline"
          onClick={addIngredient}
          className="mt-2"
        >
          <Plus className="h-4 w-4 mr-2" /> Add Ingredient
        </Button>
      </div>
    </div>
  );
};

export default IngredientsList;
